import React, { createContext, useContext, useEffect, useState } from "react";
import { URL } from "../helper/Mainurl";
import { useAuth } from "./AuthContext";

const UserInfoContext = createContext();
export const useUserInfo = () => useContext(UserInfoContext);

export const UserInfoProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { authData } = useAuth();
  const fetchProfile = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    try {
      const response = await fetch(`${URL}/v1/get-profile`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error("Failed to fetch profile");
      const data = await response.json();
      setUserInfo(data?.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [authData]);

  return (
    <UserInfoContext.Provider value={{ userInfo, loading, error, fetchProfile }}>
      {children}
    </UserInfoContext.Provider>
  );
};
